export type RecomMethod = 'GET' | 'POST' | 'PUT';

export const recomPaths = {
	recommendation: (): string => 'recommendation',
	trending: (): string => 'products/trending',
	popular: (): string => 'products/popular',
	userEvents: (): string => 'users/events',
	mergeSession: (): string => 'users/merge-session',
	recentlyViewed: (): string => 'users/recently-viewed',
	quiz: (): string => 'users/quiz',
	profile: (userId: string): string => `users/${encodeURIComponent(userId)}/profile`,
	evaluateCoupons: (): string => 'coupons/evaluate',
};

export const RECOM_ALLOWED_ROUTES: { method: RecomMethod; pattern: RegExp; query?: string[] }[] = [
	{ method: 'POST', pattern: /^recommendation$/ },
];

const findRecomRoute = (method: string, path: string) =>
	RECOM_ALLOWED_ROUTES.find((route) => route.method === method && route.pattern.test(path));

export const isAllowedRecomRoute = (method: string, path: string): boolean =>
	Boolean(findRecomRoute(method, path));

export const allowedRecomQuery = (method: string, path: string): string[] =>
	findRecomRoute(method, path)?.query ?? [];
